module.exports = __webpack_public_path__ + "media/entities/2307-09a2cf4b.png";